import React, { useRef, useState, useEffect } from 'react'; // Import useState and useEffect
import { motion } from 'framer-motion';
import HeroSection from './components/HeroSection';
import WorkSection from './components/WorkSection';
// import ServicesSection from './components/ServicesSection';
import './UltimateHome.css';
import { ScrollContext } from './components/ScrollContext';
import Cookies from 'js-cookie';
import { Link } from 'react-router-dom';

import sza from './components/CardContent/SZAPortal/platform.png';

const UltimateHome = () => {
  const token = Cookies.get('token');
  const containerRef = useRef(null);

  // ✅ STEP 1: CREATE STATE TO TRACK IF THE REF IS READY
  // We will only render the child components once this is true.
  const [isRefReady, setIsRefReady] = useState(false);
  
  console.log(`[UltimateHome] Component is rendering. Is ref ready? ${isRefReady}`);

  // ✅ STEP 2: USE an EFFECT TO UPDATE THE STATE
  // This effect runs *after* the component has mounted and the ref has been attached to the div.
  useEffect(() => {
    // Check if the ref has been attached to the DOM element
    if (containerRef.current) {
      console.log('[UltimateHome] ✅ Ref is now ATTACHED to the DOM element. The container is ready.');
      console.log(containerRef.current);
      // Update the state to trigger a re-render
      setIsRefReady(true);
    } else {
      console.log('[UltimateHome] 🟡 Ref is not yet attached on first render pass.');
    }
  }, []); // The empty dependency array [] ensures this runs only once after mount.


  return (
    // The provider passes the ref object itself, which is correct.
    <ScrollContext.Provider value={containerRef}>
      
      {/* ATTACH THE REF TO YOUR SCROLLING DIV */}
      <div className="ULTHOME-container" ref={containerRef}>
        
        {/* Color screen fade-in overlay */}
        <motion.div
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            backgroundColor: '#1f1f1e',
            zIndex: 9999,
            pointerEvents: 'none'
          }}
          initial={{ opacity: 1 }}
          animate={{ opacity: 0 }}
          transition={{ 
            duration: 1, 
            delay: 0,
            ease: "easeInOut"
          }}
        />

        {/* Header */}
        <motion.header 
          className="ULTHOME-header"
          initial={{ y: -100, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          transition={{ 
            duration: 1.2, 
            delay: 0.3,
            ease: [0.25, 0.46, 0.45, 0.94]
          }}
        >
          {/* Logo */}
          <motion.div 
            className="ULTHOME-logo" 
            style={{ backgroundImage: `url(${sza})` }}
            initial={{ scale: 0.8, opacity: 0 }}
            animate={{ scale: 1, opacity: 1 }}
            transition={{ 
              duration: 1, 
              delay: 0.8,
              ease: "easeOut"
            }}
          >      
          </motion.div>
          
          {/* Sign In Button */}
          <motion.div
            initial={{ x: 50, opacity: 0 }}
            animate={{ x: 0, opacity: 1 }}
            transition={{ 
              duration: 1, 
              delay: 1,
              ease: "easeOut"
            }}
          >
          {token ? (
                        <Link to="/dashboard" className="ULT-login">
                            Go to Dashboard
                        </Link>
                    ) : (
                        <Link to="/login" className="ULT-login">
                            Log In
                        </Link>
                    )}          </motion.div>
        </motion.header>

        {/* ✅ STEP 3: CONDITIONALLY RENDER THE CHILDREN */}
        {/* These components will now ONLY be mounted AFTER isRefReady is true, */}
        {/* guaranteeing that containerRef.current is a valid DOM element when they run. */}
        {isRefReady && (
          <>
            <HeroSection />
            <WorkSection />
            {/* <ServicesSection /> */}
          </>
        )}
      </div>
    </ScrollContext.Provider>
  );
};

export default UltimateHome;